import * as ko from "knockout";
import { c_wty_claim_defective_part, part } from "entitiesE";
import { LookupStorage } from "portalframework";
import { changeTracker } from "entitiesE";

export class warranty_defective_part extends c_wty_claim_defective_part {
  phenomenon_code_description: KnockoutComputed<string>;
  part: KnockoutObservable<part>;
  good_will_transaction_check: KnockoutComputed<boolean>;
  defective_part: KnockoutObservable<any>;
  repl_part: KnockoutObservable<any>;
  item_list_description: KnockoutComputed<string>;
  entityState: () => { isDirty: KnockoutComputed<boolean>; markCurrentStateAsClean: () => void };
  referenz: KnockoutObservable<string>;
  disposal_check_value: KnockoutComputed<boolean>;
  user_def3: KnockoutObservable<string>;
  plant: KnockoutObservable<string>;
  serialed: KnockoutObservable<boolean>;

  is_new: KnockoutObservable<boolean>;

  device_serial_id: KnockoutObservable<string>;
  request_id_kdc: KnockoutObservable<string>;

  constructor(item: any) {
    super(item);
    this.is_new = ko.observable(item?.is_new);
    this.part = ko.observable();
    if (item.part) {
      this.part(new part(item.part));
    }
    this.good_will_transaction_check = ko.pureComputed({
      read: () => {
        return this.good_will_transaction() && this.good_will_transaction() == "Y";
      },
      write: (value: boolean) => {
        this.good_will_transaction(value ? "Y" : "N");
      },
    });

    this.disposal_check_value = ko.pureComputed({
      read: () => {
        return this.disposal_check() && this.disposal_check() == "Y";
      },
      write: (value: boolean) => {
        this.disposal_check(value ? "Y" : "N");
      },
    });
    this.serialed = ko.observable();
    this.defective_part = ko.observable();
    this.defective_part.subscribe((newval) => {
      if (newval === null) {
        this.part_id(null);
        this.user_def1(null);
      } else {
        this.part_id(newval.part_id);
        this.user_def1(newval.descr);
        this.serialed(newval?.serialed === "Y");
      }
    });
    this.referenz = ko.observable(item.referenz);
    this.repl_part = ko.observable();
    this.repl_part.subscribe((newval) => {
      if (newval === null) {
        this.repl_part_id(null);
      } else {
        this.repl_part_id(newval.part_id);
      }
    });
    this.phenomenon_code_description = ko.pureComputed(() => {
      let lookupStorage = LookupStorage;
      if (lookupStorage) {
        let lookupStorage1 = lookupStorage.lookupStorage;
        if (lookupStorage1) {
          return lookupStorage1.getLookupItemDescription("C_PHENOMENOM_CODE", this.phenomenon_code());
        }
      }
    });
    this.item_list_description = ko.pureComputed(() => {
      return this.part_serial_id() ? `${this.part_serial_id()} / ${this.part_id() || "--"}` : "New Item";
    });
    this.entityState = changeTracker(this);
    this.user_def3 = ko.observable(item?.user_def3);
    this.plant = ko.observable(item?.plant);

    this.device_serial_id = ko.observable(item?.device_serial_id);
    this.request_id_kdc = ko.observable(item?.request_id_kdc);
  }

  toJSON = () => {
    let jsO = ko.toJS(this);
    delete jsO.defective_part;
    delete jsO.repl_part;
    delete jsO.good_will_transaction_check;
    delete jsO.saved;
    delete jsO.phenomenon_code_description;
    delete jsO.device_serial_id;
    delete jsO.request_id_kdc;
    return jsO;
  };
}
